import { useMapEvents } from 'react-leaflet';

function MapClickHandler({ onLocationChange }) {
  useMapEvents({
    dblclick(e) {
      const { lat: latitude, lng: longitude } = e.latlng;
      onLocationChange({ latitude, longitude });
    },
  });

  return null;
}

export default MapClickHandler;
